<!-- 绑定邮箱 -->
<template>
    <div class="main-box">
        <div class="content-main">
            <div class="top-info">
                <a-button class="back-btn" @click="goBack">
                    <template #icon>
                        <icon-left/>
                    </template>
                </a-button>
                <span>{{ $t('personal.bind_email') }}</span>
            </div>
            <!-- 加载状态 -->
            <div v-if="isLoading" class="loading-container">
                <a-spin size="large" />
                <p>{{ $t('common.loading') }}</p>
            </div>
            
            <!-- 已绑定状态 -->
            <div v-else-if="isBound" class="bound-status">
                <div class="status-card">
                    <div class="status-icon">
                        <icon-check-circle size="64" style="color: #52c41a;"/>
                    </div>
                    <h2 class="status-title">{{ $t('personal.email_bound') }}</h2>
                    <p class="status-desc">{{ $t('personal.email_bound_desc') }}</p>
                    <div class="email-info">
                        <span class="email-label">{{ $t('personal.bound_email') }}:</span>
                        <span class="email-value">{{ boundEmail }}</span>
                    </div>
                </div>
            </div>
            
            <!-- 绑定表单 -->
            <div v-else class="recommendInvite-content">
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.email') }}</span></div>
                    <a-input class="input" :placeholder="$t('personal.email_placeholder')" v-model="email" allow-clear long/>
                </div>
                <div class="recommendInvite-content-box">
                    <div class="title"><span>{{ $t('personal.verification_code') }}</span></div>
                    <a-input class="input" :placeholder="$t('personal.verification_code_placeholder')" v-model="code" allow-clear long>
                        <template #suffix>
                            <span class="get-code-btn" @click="getVerificationCode">{{ $t('personal.get_verification_code') }}</span>
                        </template>
                    </a-input>
                </div>
                <div class="recommendInvite-content-box">
                    <a-button class="confirm"
                              :disabled="email == '' || code == ''"
                              @click="handleOk">
                        {{ $t('personal.confirm') }}
                    </a-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import userApi from '@/common/api/user.js';

export default {
    components: {},
    name: 'bindEmail',
    data() {
        return {
            email: '',
            code: '',
            isLoading: true,
            isBound: false, // 是否已绑定
            boundEmail: '' // 已绑定的邮箱
        };
    },
    mounted() {
        this.getUserEmailInfo();
    },
    methods: {
        goBack() {
            this.$emit("safet-event");
        },
        async getUserEmailInfo() {
            try {
                console.log('🔍 获取用户邮箱信息...');
                const userInfo = this.$store.state.userinfo;
                console.log('用户信息:', userInfo);
                
                // 检查用户信息中的邮箱
                if (userInfo && userInfo.email) {
                    this.email = userInfo.email;
                    this.boundEmail = userInfo.email;
                    this.isBound = true;
                    console.log('✅ 用户已绑定邮箱:', this.email);
                } 
                // 检查用户账号是否是邮箱格式
                else if (userInfo && userInfo.account) {
                    const account = userInfo.account;
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (emailRegex.test(account)) {
                        this.email = account;
                        this.boundEmail = account;
                        this.isBound = true;
                        console.log('✅ 用户账号是邮箱格式:', account);
                    } else {
                        console.log('ℹ️ 用户账号不是邮箱格式');
                        this.isBound = false;
                    }
                }
                // 检查缓存中的登录邮箱
                else {
                    const cachedEmail = this.$util.getCache('login_email');
                    if (cachedEmail) {
                        this.email = cachedEmail;
                        this.boundEmail = cachedEmail;
                        this.isBound = true;
                        console.log('✅ 从缓存中找到登录邮箱:', cachedEmail);
                    } else {
                        console.log('ℹ️ 用户未绑定邮箱');
                        this.isBound = false;
                    }
                }
                
                console.log('📧 最终邮箱绑定状态:', {
                    isBound: this.isBound,
                    email: this.email,
                    boundEmail: this.boundEmail
                });
            } catch (error) {
                console.error('❌ 获取用户邮箱信息失败:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async handleOk() {
            if (!this.email || !this.code) {
                this.$message.error(this.$t('register.fill_complete_info'));
                return;
            }
            
            try {
                const submitData = {
                    email: this.email,
                    code: this.code
                };
                
                console.log('提交邮箱绑定数据:', submitData);
                
                // 调用绑定邮箱API
                const response = await userApi.submitBindEmail(submitData);
                
                if (response && response.code === 200) {
                    this.$message.success(this.$t('personal.email_binding_success'));
                    // 更新本地用户信息
                    this.$store.commit('updateUserEmail', this.email);
                    setTimeout(() => {
                        this.goBack();
                    }, 1500);
                } else {
                    this.$message.error(response?.message || '绑定失败，请重试');
                }
            } catch (error) {
                console.error('绑定邮箱失败:', error);
                this.$message.error(this.$t('personal.binding_code_invalid'));
            }
        },
        async getVerificationCode() {
            if (!this.email) {
                this.$message.error(this.$t('personal.email_required'));
                return;
            }
            
            // 验证邮箱格式
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email)) {
                this.$message.error(this.$t('register.email_format_incorrect'));
                return;
            }
            
            try {
                console.log('获取邮箱验证码:', this.email);
                
                // 调用发送验证码API
                const response = await userApi.sendEmailCode();
                
                if (response && response.code === 200) {
                    this.$message.success(this.$t('personal.verification_code_email_sent'));
                } else {
                    this.$message.error(response?.message || this.$t('personal.verification_code_send_failed'));
                }
            } catch (error) {
                console.error('发送验证码失败:', error);
                this.$message.error(this.$t('personal.verification_code_send_failed'));
            }
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./bindEmail.scss";
</style>
  
